<div class="card-footer p-2">
  <div class="column-grid-container">
    <div></div>
    <div class="middle-column">
      <ngb-pagination (pageChange)="onPageChange($event)"
                      [(page)]="page"
                      [boundaryLinks]="true"
                      [collectionSize]="collectionSize"
                      [maxSize]="5"
                      [pageSize]="pageSize"
                      [rotate]="true"
                      [size]="'lg'">
      </ngb-pagination>
    </div>
    <div class="right-column">
      <label>{{'SHOW' | translate}}
        <select (ngModelChange)="onPageSizeChange($event)"
                [(ngModel)]="pageSize"
                class="form-control"
                id="onPageSizeChange">
          <option *ngFor="let size of pageSizes" [ngValue]="size">{{ size }}</option>
        </select>
        {{'ENTRIES' | translate}}</label>
    </div>
  </div>
</div>
